import {
  EMAIL_ATTACHMENT_MAX_BYTES,
  MessagingPlatform,
} from '@this+that/models';

import { resolveEmailAccount } from './resolveEmailAccount';
import { useIntegrationsStore } from '../../../store';
import {
  INLINE_EMAIL_ATTACHMENT_MAX_BYTES,
  S3_ATTACHMENT_PLATFORMS,
} from '../../../utils/constants/drafts';

// S3-backed providers take EMAIL_ATTACHMENT_MAX_BYTES; anything else still rides inline in the JSON.
export const resolveEmailAttachmentLimit = (
  platform: MessagingPlatform | undefined,
): number =>
  platform && S3_ATTACHMENT_PLATFORMS.has(platform)
    ? EMAIL_ATTACHMENT_MAX_BYTES
    : INLINE_EMAIL_ATTACHMENT_MAX_BYTES;

export const useEmailAttachmentLimit = (
  fromEmail: string | undefined,
): number => {
  const { currentIntegrationAccount, integrationAccounts } =
    useIntegrationsStore();
  return resolveEmailAttachmentLimit(
    currentIntegrationAccount
      ? resolveEmailAccount(
          fromEmail,
          currentIntegrationAccount,
          integrationAccounts,
        )?.platform
      : undefined,
  );
};
